/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import { jsx } from '@emotion/react'; // eslint-disable-line @atlaskit/ui-styling-standard/use-compiled

import CheckMarkIcon from '@atlaskit/icon/utility/check-mark';
import ChevronRightIcon from '@atlaskit/icon/utility/migration/chevron-right';
import { HeadingItem } from '@atlaskit/menu';
import { ContextualToolbarIcon } from './icons/ContextualToolbarIcon';
import { FixedToolbarIcon } from './icons/FixedToolbarIcon';
// New editor controls
export var getOverflowFloatingToolbarConfig = function getOverflowFloatingToolbarConfig(_ref) {
  var api = _ref.api,
    toolbarDocking = _ref.toolbarDocking;
  var dropdownOptions = [{
    title: 'Create Jira issue',
    onClick: function onClick() {
      return false;
    },
    elemAfter: jsx(ChevronRightIcon, {
      spacing: "spacious",
      label: ""
    })
  }, {
    title: 'Define',
    onClick: function onClick() {
      return false;
    }
  }, {
    title: 'Apps',
    onClick: function onClick() {
      return false;
    },
    elemAfter: jsx(ChevronRightIcon, {
      spacing: "spacious",
      label: ""
    })
  }];
  if (toolbarDocking === 'none') {
    dropdownOptions.push({
      type: 'overflow-dropdown-heading',
      title: 'Toolbar appears'
    }, {
      title: 'In-line with text',
      onClick: function onClick() {
        var _api$selectionToolbar, _api$selectionToolbar2, _api$selectionToolbar3;
        return (_api$selectionToolbar = api === null || api === void 0 || (_api$selectionToolbar2 = api.selectionToolbar.actions) === null || _api$selectionToolbar2 === void 0 || (_api$selectionToolbar3 = _api$selectionToolbar2.setToolbarDocking) === null || _api$selectionToolbar3 === void 0 ? void 0 : _api$selectionToolbar3.call(_api$selectionToolbar2, 'none')) !== null && _api$selectionToolbar !== void 0 ? _api$selectionToolbar : false;
      },
      icon: jsx(ContextualToolbarIcon, {
        label: "Contextual toolbar"
      }),
      selected: true,
      elemAfter: jsx(CheckMarkIcon, {
        label: ""
      })
    }, {
      title: 'Fixed at top',
      onClick: function onClick() {
        var _api$selectionToolbar4, _api$selectionToolbar5, _api$selectionToolbar6;
        return (_api$selectionToolbar4 = api === null || api === void 0 || (_api$selectionToolbar5 = api.selectionToolbar.actions) === null || _api$selectionToolbar5 === void 0 || (_api$selectionToolbar6 = _api$selectionToolbar5.setToolbarDocking) === null || _api$selectionToolbar6 === void 0 ? void 0 : _api$selectionToolbar6.call(_api$selectionToolbar5, 'top')) !== null && _api$selectionToolbar4 !== void 0 ? _api$selectionToolbar4 : false;
      },
      icon: jsx(FixedToolbarIcon, {
        label: "Fixed toolbar"
      })
    });
  }
  return [{
    type: 'separator',
    fullHeight: true
  }, {
    type: 'overflow-dropdown',
    dropdownWidth: 240,
    options: dropdownOptions
  }];
};
export var getOverflowPrimaryToolbarConfig = function getOverflowPrimaryToolbarConfig(_ref2) {
  var api = _ref2.api;
  return [{
    items: [{
      content: jsx(HeadingItem, null, "Toolbar appears"),
      value: {
        name: ''
      },
      isDisabled: true
    }, {
      content: 'In-line with text',
      value: {
        name: 'contextual'
      },
      onClick: function onClick() {
        var _api$selectionToolbar7, _api$selectionToolbar8, _api$selectionToolbar9;
        return (_api$selectionToolbar7 = api === null || api === void 0 || (_api$selectionToolbar8 = api.selectionToolbar.actions) === null || _api$selectionToolbar8 === void 0 || (_api$selectionToolbar9 = _api$selectionToolbar8.setToolbarDocking) === null || _api$selectionToolbar9 === void 0 ? void 0 : _api$selectionToolbar9.call(_api$selectionToolbar8, 'none')) !== null && _api$selectionToolbar7 !== void 0 ? _api$selectionToolbar7 : false;
      },
      elemBefore: jsx(ContextualToolbarIcon, {
        label: "Contextual toolbar"
      })
    }, {
      content: 'Fixed at top',
      value: {
        name: 'fixed'
      },
      onClick: function onClick() {
        var _api$selectionToolbar10, _api$selectionToolbar11, _api$selectionToolbar12;
        return (_api$selectionToolbar10 = api === null || api === void 0 || (_api$selectionToolbar11 = api.selectionToolbar.actions) === null || _api$selectionToolbar11 === void 0 || (_api$selectionToolbar12 = _api$selectionToolbar11.setToolbarDocking) === null || _api$selectionToolbar12 === void 0 ? void 0 : _api$selectionToolbar12.call(_api$selectionToolbar11, 'top')) !== null && _api$selectionToolbar10 !== void 0 ? _api$selectionToolbar10 : false;
      },
      isActive: true,
      elemBefore: jsx(FixedToolbarIcon, {
        label: "Fixed toolbar"
      }),
      elemAfter: jsx(CheckMarkIcon, {
        label: ""
      })
    }]
  }];
};